import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { domainActions } from '../../../store/domainStore';
import { connect as connectFormik } from 'formik';
import { BbSelectNoFormik } from '../../styling/bbInput';

class CountryField extends React.Component {

    constructor(props) {
        super(props);

        this.props.ensureDomainData('countries');
    }

    componentDidUpdate() {
        this.props.ensureDomainData('countries');
    }

    componentDidMount() {
        this.props.ensureDomainData('countries');
    }

    render() {
        const countries = this.getCountry();
        return (
            <BbSelectNoFormik formatOptionLabel={formatOptionLabel}
                onChange={(e) => this.props.formik.setFieldValue(this.props.fieldName, e.value)}
                options={countries}
                value={countries.find(f => f.value === this.props.country)}/>);
    }

    getCountry() {
        const defaultChoice = { value: "", label: "" };

        var data = this.props.countries.requestResult ? this.props.countries.requestResult : [defaultChoice];

        const countries = (data)
            .filter(country => typeof this.props.filter === 'function' ? this.props.filter(country) : true);

        return [defaultChoice, ...countries.map((c) => { return { label: c.label, value: c.value } })];

    }
}

const formatOptionLabel = ({ value, label, shortening }) => (
    <div style={{ display: "flex" }}>
        <div value={value} key={value} >{label}</div>
    </div>
);

export default connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(CountryField));